export default "__VITE_ASSET__BDHa1Nj8__"